import { Footer } from "@/components/Footer";
import { LandingNav } from "@/components/landing/LandingNav";
import { Hero } from "@/components/landing/Hero";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { Examples } from "@/components/landing/Examples";
import { FxShowcase } from "@/components/landing/FxShowcase";
import { Platforms, FreePlan } from "@/components/landing/PlatformsFree";
import { Faq, FinalCta } from "@/components/landing/FaqCta";

export default function Landing() {
  return (
    <div className="min-h-screen bg-[#04050a] text-slate-200" data-testid="landing-page">
      <LandingNav />
      <main>
        <Hero />
        <HowItWorks />
        <Examples />
        <FxShowcase />
        <Platforms />
        <FreePlan />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
